<p-toast></p-toast>
<div class="app-verification-container">
    <p-card styleClass="p-card-shadow">
        <div class="card">
            <h4>{{'LIST_OF_WATRER_TANK_TO_BE_VERIFIED' | translate}}</h4>
            <p-table #tankTable [value]="tankData" [rows]="10" [paginator]="true"
                [globalFilterFields]="['srNo', 'appID', 'FarmerName','district', 'block', 'village',  'Total_Area', 'AgeOfApplication', 'LandDetail', 'status', 'remarks']"
                responsiveLayout="scroll" [(selection)]="tankData" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [showCurrentPageReport]="true">

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="srNO">{{'SR_NO' | translate}}
                            <p-columnFilter type="text" field="srNO" display="menu"></p-columnFilter>
                            <p-sortIcon field="srNO"></p-sortIcon>
                        </th>

                        <th pSortableColumn="appID">{{'APP_ID' | translate}}
                            <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
                            <p-sortIcon field="appID"></p-sortIcon>
                        </th>

                        <th pSortableColumn="FarmerName">{{'FARMER_NAME' | translate}}
                            <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerName"></p-sortIcon>
                        </th>

                        <th pSortableColumn="district">{{'DISTRICT' | translate}}
                            <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
                            <p-sortIcon field="district"></p-sortIcon>
                        </th>

                        <th pSortableColumn="block">{{'BLOCK' | translate}}
                            <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
                            <p-sortIcon field="block"></p-sortIcon>
                        </th>

                        <th pSortableColumn="village">{{'VILLAGE' | translate}}
                            <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                            <p-sortIcon field="village"></p-sortIcon>
                        </th>



                        <th pSortableColumn="Total_Area">{{'TOTAL_AREA' | translate}}
                            <p-columnFilter type="text" field="Total_Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Total_Area"></p-sortIcon>
                        </th>

                        <th pSortableColumn="AgeOfApplication">{{'AGE_OF_APPLICATION' | translate}}
                            <p-columnFilter type="text" field="AgeOfApplication" display="menu"></p-columnFilter>
                            <p-sortIcon field="AgeOfApplication"></p-sortIcon>
                        </th>

                        <th pSortableColumn="LandDetail">{{'LAND_DETAILS' | translate}}
                            <p-columnFilter type="text" field="LandDetail" display="menu"></p-columnFilter>
                            <p-sortIcon field="LandDetail"></p-sortIcon>
                        </th>

                        <th pSortableColumn="status">{{'STATUS' | translate}}
                            <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
                            <p-sortIcon field="status"></p-sortIcon>
                        </th>

                        <th pSortableColumn="remarks">{{'REMARKS' | translate}}
                            <p-columnFilter type="text" field="remarks" display="menu"></p-columnFilter>
                            <p-sortIcon field="remarks"></p-sortIcon>
                        </th>

                        <th>{{'ACTION' | translate}}</th>

                    </tr>

                </ng-template>

                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td>{{rowIndex + 1}}</td>
                        <td>{{product.appID}}</td>
                        <td>{{product.FarmerName}}</td>
                        <td>{{product.district}}</td>
                        <td>{{product.block}}</td>
                        <td>{{product.village}}</td>
                        <td>{{product.Total_Area}}</td>
                        <td>{{product.AgeOfApplication}}</td>
                        <td>{{product.LandDetail}}</td>
                        <td>{{product.status}}</td>
                        <td>{{product.remarks}}</td>
                        <td><button (click)="selectTankRowData(product)" pButton pRipple type="button"
                                label="{{'FILL_DETAILS' | translate}}" class="p-button-success mr-2 mb-2"></button></td>
                        <!-- <td><button (click)="selectTankRowData2(product)" pButton pRipple type="button"
                                label="Fill Details" class="p-button-success mr-2 mb-2"></button></td> -->
                    </tr>
                </ng-template>

            </p-table>
        </div>
    </p-card>
</div>

<!-- Tank Dialog Starts Here -->

<p-dialog [(visible)]="displayTankDialog" [modal]="true" [style]="{width: '100%',height:'100%'}" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="onCloseDialog()">

    <div class="app-verification-container">
        <p-card styleClass="p-card-shadow">
            <h4>{{'LIST_OF_WATRER_TANK_TO_BE_VERIFIED' | translate}}</h4>
            <!-- Table Dialog Starts Here -->
            <!-- <div class="card" style="margin: 5px;">
                <p-table [value]="dialogData" [rows]="10" [paginator]="true"
                [globalFilterFields]="['srNo', 'appID','farmerName', 'district', 'block', 'village',  'totalArea', 'ageOfApplication', 'landDetail', 'status', 'remarks']"
                responsiveLayout="scroll" [(selection)]="dialogData" [rowHover]="true" dataKey="id"
                [showCurrentPageReport]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="srNO">Sr. No.
                        </th>
                        <th pSortableColumn="aapID">APP ID
                            <p-columnFilter type="text" field="aapID" display="menu"></p-columnFilter>
                            <p-sortIcon field="aapID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="farmerName">Farmer Name
                            <p-columnFilter type="text" field="farmerName" display="menu"></p-columnFilter>
                            <p-sortIcon field="farmerName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="district">District
                            <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
                            <p-sortIcon field="district"></p-sortIcon>
                        </th>
                        <th pSortableColumn="block">Block
                            <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
                            <p-sortIcon field="block"></p-sortIcon>
                        </th>
                        <th pSortableColumn="village">Village
                            <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                            <p-sortIcon field="village"></p-sortIcon>
                        </th>
                        <th pSortableColumn="totalArea">Total Area
                            <p-columnFilter type="text" field="totalArea" display="menu"></p-columnFilter>
                            <p-sortIcon field="totalArea"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ageOfApplication">Age of Application
                            <p-columnFilter type="text" field="ageOfApplication" display="menu"></p-columnFilter>
                            <p-sortIcon field="ageOfApplication"></p-sortIcon>
                        </th>
                        <th pSortableColumn="landDetail">Land Detail
                            <p-columnFilter type="text" field="landDetail" display="menu"></p-columnFilter>
                            <p-sortIcon field="landDetail"></p-sortIcon>
                        </th>
                        <th pSortableColumn="status">Status
                            <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
                            <p-sortIcon field="status"></p-sortIcon>
                        </th>
                        <th pSortableColumn="remarks">Remarks
                            <p-columnFilter type="text" field="remarks" display="menu"></p-columnFilter>
                            <p-sortIcon field="remarks"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>      
                    <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                        <tr>
                            <td>{{rowIndex + 1}}</td>
                            <td>{{product.appID}}</td>
                            <td>{{product.FarmerName}}</td>
                            <td>{{product.district}}</td>
                            <td>{{product.block}}</td>
                            <td>{{product.village}}</td>
                            <td>{{product.Total_Area}}</td>
                            <td>{{product.AgeOfApplication}}</td>
                            <td>{{product.LandDetail}}</td>
                            <td>{{product.status}}</td>
                            <td>{{product.remarks}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div> -->
            <!-- Table Dialog End -->

            <div class="col-12">
                <!-- <h4 style="text-align: center;" class="mt-7">Tank Details <span style="color: red;">(Tank Size In Meters
                        Only)</span></h4> -->

                <!-- <div class="field-checkbox justify-content-center">
                    <label for="sf" class="px-3">Wrong Notification</label>
                    <p-checkbox name="group1" value="" inputId="sf" (onChange)="wrongNotification($event)"></p-checkbox>
                </div> -->
                <!-- <div class="field-checkbox justify-content-center"> -->
                <div class="field-checkbox justify-content-center">
                    <label>{{'SELECT_ACTION' | translate}}</label>
                </div><br>
                <div class="field-checkbox justify-content-center">
                    <p-dropdown [options]='[{name: "Tank Verification"}, {name: "False Intimation"}]' optionLabel="name"
                        (onChange)="wrongNotification($event)">
                    </p-dropdown>
                </div>
                <div class="justify-content-center">
                    <label htmlFor="applicationID">{{'APPLICATION_ID' | translate}} : {{appID}}</label>
                </div>

                <!-- ESTIMATION FORM -->
                <div *ngIf="wrongNotificationCheck">
                    <div class="col-12">
                        <div class="card estiamtion-header">
                            <form [formGroup]="submitEstimateForm">

                                <div class="p-fluid p-formgrid grid">
                                    <!-- <div class="field col-12 md:col-2">
                                <label htmlFor="applicationID">Application ID : {{appID}}</label>
                            </div> -->

                                    <div class="field col-12 md:col-4" *ngIf="wrongNotificationCheck">
                                        <label htmlFor="topSizeLength">{{'TOP_SIZE' | translate}} :
                                            <div class="d-flex justify-content-between">
                                            <div
                                                *ngIf="tankFormControls.topSizeLength.touched && tankFormControls.topSizeLength.valid">
                                                {{'LENGTH' | translate}} : {{submitEstimateForm.get('topSizeLength').value}}
                                            </div>
                                            <div
                                                *ngIf="tankFormControls.topSizeBreadth.touched && tankFormControls.topSizeBreadth.valid">
                                                {{'BREADTH' | translate}} : {{submitEstimateForm.get('topSizeBreadth').value}}
                                            </div>
                                            </div>
                                        </label>
                                        <input formControlName="topSizeLength" pInputText id="topSizeLength"
                                            type="number" placeholder="Length"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.topSizeLength.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.topSizeLength.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.topSizeLength.errors.required">{{'LENGTH_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>

                                        <p class="text-center mt-3">X</p>

                                        <input formControlName="topSizeBreadth" pInputText id="topSizeBreadth"
                                            type="number" placeholder="Breadth"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.topSizeBreadth.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.topSizeBreadth.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.topSizeBreadth.errors.required">{{'BREADTH_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                        <label htmlFor="bottomSizeLength">{{'BOTTOM_SIZE' | translate}} :
                                            <div
                                                *ngIf="tankFormControls.bottomSizeLength.touched && tankFormControls.bottomSizeLength.valid">
                                                {{'LENGTH' | translate}} : {{submitEstimateForm.get('bottomSizeLength').value}}
                                            </div>
                                            <div
                                                *ngIf="tankFormControls.bottomSizeBreadth.touched && tankFormControls.bottomSizeBreadth.valid">
                                                {{'BREADTH' | translate}} : {{submitEstimateForm.get('bottomSizeBreadth').value}}
                                            </div>
                                        </label>
                                        <input formControlName="bottomSizeLength" pInputText id="bottomSizeLength"
                                            type="number" placeholder="Length"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.bottomSizeLength.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.bottomSizeLength.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.bottomSizeLength.errors.required">{{'LENGTH_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>

                                        <p class="text-center mt-3">X</p>

                                        <input formControlName="bottomSizeBreadth" pInputText id="bottomSizeBreadth"
                                            type="number" placeholder="Breadth"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.bottomSizeBreadth.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.bottomSizeBreadth.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.bottomSizeBreadth.errors.required">{{'BREADTH_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                        <label htmlFor="depth">{{'DEPTH' | translate}} : </label>
                                        <input formControlName="depth" pInputText id="depth" type="number"
                                            placeholder="Depth"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.depth.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.depth.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.depth.errors.required">{{'DEPTH_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                        <label htmlFor="latitude">{{'LATITUDE' | translate}} : </label>
                                        <input formControlName="latitude" pInputText id="latitude" type="number"
                                            placeholder="Latitude"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.latitude.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.latitude.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.latitude.errors.required">{{'LATITUDE_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                        <label htmlFor="longitude">{{'LONGITUDE' | translate}} : </label>
                                        <input formControlName="longitude" pInputText id="longitude" type="number"
                                            placeholder="Longitude"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.longitude.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.longitude.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.longitude.errors.required">{{'LONGITUDE_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                        <label htmlFor="volumeOfEarthWork">{{'VOLUME_OF_EARTHWORK_CUM/CFT' | translate}} : </label>
                                        <input formControlName="volumeOfEarthWork" pInputText id="volumeOfEarthWork"
                                            type="number" placeholder="Volume of earthWork"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.volumeOfEarthWork.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.volumeOfEarthWork.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.volumeOfEarthWork.errors.required">{{'VOLUME_OF_EARTHWORK_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                        <label htmlFor="totalCostOfEarthWork">{{'TOTAL_COST_OF_EARTH_WORK_AS_PER_MB_OF_JE' | translate}} :
                                        </label>
                                        <input formControlName="totalCostOfEarthWork" pInputText
                                            id="totalCostOfEarthWork" type="number"
                                            placeholder="Enter Total cost of earthWork"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.totalCostOfEarthWork.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.totalCostOfEarthWork.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.totalCostOfEarthWork.errors.required">{{'TOTAL_COST_OF_EARTHWORK_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                        <label htmlFor="amountOfSubsidy">{{'AMOUNT_OF_SUBSIDY_OF_EARTH_WORK' | translate}} :
                                        </label>
                                        <input formControlName="amountOfSubsidy" pInputText id="amountOfSubsidy"
                                            type="number" placeholder="Enter Amount of Subsidy"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.amountOfSubsidy.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.amountOfSubsidy.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.amountOfSubsidy.errors.required">{{'AMOUNT_OF_SUBSIDY_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>



                                    <!-- <div class="field col-12 md:col-4">
                            <label htmlFor="remarks">Remarks : </label>
                            <input formControlName="remarks" pInputText id="remarks" type="text" placeholder="Remarks"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.remarks.errors }" />
                            <div *ngIf="isSubmitted && tankFormControls.remarks.errors" class="invalid-feedback">
                                <div *ngIf="tankFormControls.remarks.errors.required">Remarks is required
                                </div>
                            </div>
                        </div> -->

                                    <div class="field col-12 md:col-4">
                                        <label htmlFor="block">{{'UPLOAD_MEASUREMENT_BOOK_COPY' | translate}} :</label>
                                        <div class="flex">
                                            <p-fileUpload accept=".jpeg,.pdf,.jpg" #measurementBookCopyPath
                                                [customUpload]="true"
                                                (uploadHandler)="onUpload($event, 'measurementBookCopyPath', measurementBookCopyPath,1)"
                                                name="myfile[]" mode="basic" [maxFileSize]="1000000"
                                                chooseLabel="Browse" [auto]="true">
                                            </p-fileUpload>
                                            <p-image *ngIf="tankFormControls.measurementBookCopyPath.value"
                                                [src]="tankFormControls.measurementBookCopyPath.value" alt="Image"
                                                width="60" class="ml-2 p-button-rounded p-button-success"
                                                iconPos="left"></p-image>

                                        </div>
                                        <div *ngIf="isSubmitted && tankFormControls.measurementBookCopyPath.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.measurementBookCopyPath.errors.required">
                                                {{'MEASUREMENT_BOOK_COPY_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </form>
                        </div>

                        <div>
                            <span style="font-weight: bold;">{{'NOTE' | translate}}: </span>
                            <span style="color: #EA5455;">{{'PLEASE_FILL_DETAILS_PHYSICAL_VERIFICATION' | translate}}</span>
                        </div>
                    </div>

                    <div class="card dropdown-content" style="margin: 5px;">
                        <div class="p-fluid p-formgrid grid d-flex justify-content-end">
                            <!-- <p-toolbar styleClass="mb-4">
                        <ng-template pTemplate="right"> -->

                            <div class="field col-12 md:col-2">
                                <br>
                                <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                                    class="mr-3"></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-2">
                                <textarea id="description" [(ngModel)]="stage1EstimateFormRemarks" placeholder="Remarks"
                                    pInputTextarea required rows="3" cols="20" class="mr-3"></textarea>
                            </div>
                            <div class="field col-12 md:col-2">
                                <br>
                                <button pButton pRipple label="{{'SUBMIT' | translate}}" type="submit" (click)="submitEstimate()"
                                    class="p-button-help"></button>
                            </div>

                            <!-- </ng-template>
                    </p-toolbar> -->
                        </div>
                    </div>
                </div>


                <ng-template [ngIf]="!wrongNotificationCheck">
                    <div class="col-12">
                        <div class="card intimation-header">
                            <form [formGroup]="submitFalseIntimateForm" (onChange)="wrongNotification($event)">
                                <div class="p-fluid p-formgrid grid">
                                    <!-- <div class="field col-12 md:col-2">
                                <label htmlFor="applicationID">Application ID : {{appID}}</label>
                            </div> -->


                                    <div class="field col-12 md:col-2">
                                        <label htmlFor="uploadThePhotoTaken">{{'UPLOAD_THE_PHOTO_TAKEN'| translate}}* : </label>
                                        <div class="flex">
                                            <p-fileUpload accept=".jpeg,.pdf,.jpg" #uploadThePhotoTaken
                                                [customUpload]="true"
                                                (uploadHandler)="onUpload($event, 'uploadThePhotoTaken', uploadThePhotoTaken,2)"
                                                name="myfile[]" mode="basic" [maxFileSize]="1000000"
                                                chooseLabel="Browse" [auto]="true">
                                            </p-fileUpload>
                                            <p-image *ngIf="falseIntimationFormControls.uploadThePhotoTaken.value"
                                                [src]="falseIntimationFormControls.uploadThePhotoTaken.value"
                                                alt="Image" width="60" class="ml-2 p-button-rounded p-button-success"
                                                iconPos="left"></p-image>
                                        </div>
                                    </div>
                                    <!-- <div class="field col-12 md:col-2">
                            <label htmlFor="remarks">Remarks : </label>
                            <input formControlName="remarks" pInputText id="remarks" type="text" placeholder="Remarks"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && falseIntimationFormControls.remarks.errors }" />
                            <div *ngIf="isSubmitted && falseIntimationFormControls.remarks.errors"
                                class="invalid-feedback">
                                <div *ngIf="falseIntimationFormControls.remarks.errors.required">Remarks is required
                                </div>
                            </div>
                        </div> -->

                                </div>
                                <div>
                                    <span style="font-weight: bold;">{{'NOTE' | translate}}: </span>
                                    <span style="color: #EA5455;">{{'ONLY_JPG,PNG_OR_PDF_PHOTO_ALLOWED' | translate}}.</span>
                                </div>

                                <!-- <button (click)="submitFalseIntimate()" pButton pRipple type="submit" label="Submit Estimate"
                            class="p-button-success mr-2 mb-2"></button> -->

                            </form>
                        </div>
                    </div>
                    <br>
                    <div class="card dropdown-content" style="margin: 5px;">
                        <div class="p-fluid p-formgrid grid d-flex justify-content-end">
                            <div class="field col-12 md:col-2">
                                <br>
                                <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                                    class="mr-3"></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-2">
                                <textarea id="description" [(ngModel)]="stage1FalseIntimationremarks"
                                    placeholder="Remarks" pInputTextarea required rows="3" cols="20"
                                    class="mr-3"></textarea>
                            </div>
                            <div class="field col-12 md:col-2">
                                <br>
                                <button pButton pRipple label="{{'SUBMIT' | translate}}" type="submit" (click)="submitFalseIntimate()"
                                    class="p-button-help"></button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </p-card>
    </div>
</p-dialog>
<!-- Tank Dialog End Here -->

<!-- Tank Dialog 2 -->
<p-dialog [(visible)]="displayTankDialog2" [modal]="true" [style]="{width: '100%',height:'100%'}" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="onCloseDialog()">

    <div class="app-verification-container">
        <p-card styleClass="p-card-shadow">
            <h4>{{'LIST_OF_WATER_TANK_STAGE_2' | translate}}</h4>
            <!-- Table Dialog Starts Here -->
            <div class="card" style="margin: 5px;">
                <p-table #tankTable [value]="dialogData2" [rows]="10" [paginator]="true"
                    [globalFilterFields]="['srNo', 'appID','farmerName', 'district', 'block', 'village',  'totalArea', 'ageOfApplication', 'landDetail', 'status', 'remarks']"
                    responsiveLayout="scroll" [(selection)]="dialogData" [rowHover]="true" dataKey="id"
                    [showCurrentPageReport]="true">

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="srNO">{{'SR_NO' | translate}}
                                <p-columnFilter type="text" field="srNO" display="menu"></p-columnFilter>
                                <p-sortIcon field="srNO"></p-sortIcon>
                            </th>

                            <th pSortableColumn="appID">{{'APP_ID' | translate}}
                                <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
                                <p-sortIcon field="appID"></p-sortIcon>
                            </th>

                            <th pSortableColumn="farmerName">{{'FARMER_NAME' | translate}}
                                <p-columnFilter type="text" field="farmerName" display="menu"></p-columnFilter>
                                <p-sortIcon field="farmerName"></p-sortIcon>
                            </th>

                            <th pSortableColumn="district">{{'DISTRICT' | translate}}
                                <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
                                <p-sortIcon field="district"></p-sortIcon>
                            </th>

                            <th pSortableColumn="block">{{'BLOCK' | translate}}
                                <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
                                <p-sortIcon field="block"></p-sortIcon>
                            </th>

                            <th pSortableColumn="village">{{'VILLAGE' | translate}}
                                <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                                <p-sortIcon field="village"></p-sortIcon>
                            </th>

                            <th pSortableColumn="totalArea">{{'TOTAL_AREA' | translate}}
                                <p-columnFilter type="text" field="totalArea" display="menu"></p-columnFilter>
                                <p-sortIcon field="totalArea"></p-sortIcon>
                            </th>

                            <th pSortableColumn="ageOfApplication">{{'AGE_OF_APPLICATION' | translate}}
                                <p-columnFilter type="text" field="ageOfApplication" display="menu"></p-columnFilter>
                                <p-sortIcon field="ageOfApplication"></p-sortIcon>
                            </th>

                            <th pSortableColumn="landDetail">{{'LAND_DETAILS' | translate}}
                                <p-columnFilter type="text" field="landDetail" display="menu"></p-columnFilter>
                                <p-sortIcon field="landDetail"></p-sortIcon>
                            </th>

                            <th pSortableColumn="status">{{'STATUS' | translate}}
                                <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
                                <p-sortIcon field="status"></p-sortIcon>
                            </th>

                            <th pSortableColumn="remarks">{{'REMARKS' | translate}}
                                <p-columnFilter type="text" field="remarks" display="menu"></p-columnFilter>
                                <p-sortIcon field="remarks"></p-sortIcon>
                            </th>

                        </tr>

                    </ng-template>

                    <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                        <tr>
                            <td>{{rowIndex + 1}}</td>
                            <td>{{product.appID}}</td>
                            <td>{{product.FarmerName}}</td>
                            <td>{{product.district}}</td>
                            <td>{{product.block}}</td>
                            <td>{{product.village}}</td>
                            <td>{{product.Total_Area}}</td>
                            <td>{{product.AgeOfApplication}}</td>
                            <td>{{product.LandDetail}}</td>
                            <td>{{product.status}}</td>
                            <td>{{product.remarks}}</td>
                        </tr>
                    </ng-template>

                </p-table>
            </div>
            <!-- Table Dialog End -->



            <!-- Table Dialog-2 Starts Here -->
            <p-table #tankTable [value]="dialogData2" [rows]="6" [paginator]="true"
                [globalFilterFields]="['srNo', 'typeOfFarmer','assistancePaid@', 'subsidyPaidAt1stStage', 'measurementBookTankStage1', 'paymentStatus']"
                responsiveLayout="scroll" [(selection)]="dialogData2" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [showCurrentPageReport]="true">

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="srNO">{{'SR_NO' | translate}}
                            <p-columnFilter type="text" field="srNO" display="menu"></p-columnFilter>
                            <p-sortIcon field="srNO"></p-sortIcon>
                        </th>

                        <th pSortableColumn="typeOfFarmer">{{'TYPE_OF_FARMER' | translate}}
                            <p-columnFilter type="text" field="typeOfFarmer" display="menu"></p-columnFilter>
                            <p-sortIcon field="typeOfFarmer"></p-sortIcon>
                        </th>

                        <th pSortableColumn="assistancePaid">{{'ASSISTANCE_PAID' | translate}}
                            <p-columnFilter type="text" field="assistancePaid" display="menu"></p-columnFilter>
                            <p-sortIcon field="assistancePaid"></p-sortIcon>
                        </th>

                        <th pSortableColumn="subsidyPaidAt1stStage">{{'SUBSIDY_PAID_AT_STAGE' | translate}}
                            <p-columnFilter type="text" field="subsidyPaidAt1stStage" display="menu"></p-columnFilter>
                            <p-sortIcon field="subsidyPaidAt1stStage"></p-sortIcon>
                        </th>

                        <th pSortableColumn="measurementBookTankStage1">{{'MEASUREMENT_BOOK_TANK_STAGE' | translate}}
                            <p-columnFilter type="text" field="measurementBookTankStage1" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="measurementBookTankStage1"></p-sortIcon>
                        </th>

                        <th pSortableColumn="paymentStatus">{{'PAYMENT_STATUS' | translate}}
                            <p-columnFilter type="text" field="paymentStatus" display="menu"></p-columnFilter>
                            <p-sortIcon field="paymentStatus"></p-sortIcon>
                        </th>

                    </tr>

                </ng-template>

                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td>{{rowIndex + 1}}</td>
                        <td>{{product.typeOfFarmer}}</td>
                        <td>{{product.assistancePaid}}</td>
                        <td>{{product.subsidyPaidAt1stStage}}</td>
                        <td>{{product.measurementBookTankStage1}}</td>
                        <td>{{product.paymentStatus}}</td>
                    </tr>
                </ng-template>
            </p-table>
            <!-- Table Dialog-2 Ends Here -->
            <br>

            <div class="col-12">
                <!-- <h4 style="text-align: center;" class="mt-7">Tank Details <span style="color: red;">(Tank Size In Meters
                        Only)</span></h4> -->
                <div class="field-checkbox justify-content-center">
                    <label>{{'SELECT_ACTION' | translate}}</label><br>
                </div>
                <div class="field-checkbox justify-content-center">
                    <p-dropdown [options]='[{name: "Tank Verification"}, {name: "False Intimation"}]' optionLabel="name"
                        (onChange)="wrongNotification2($event)">
                    </p-dropdown>
                </div>

                <div>
                    <label htmlFor="applicationID">{{'APPLICATION_ID' | translate}} : {{appID}}</label>
                </div>
                <!-- ESTIMATION FORM -->
                <div *ngIf="wrongNotificationCheck2">
                    <div class="col-12">
                        <div class="card intimation-header">
                            <form [formGroup]="submitEstimateFormStage2">
                                <div class="p-fluid p-formgrid grid">
                                    <!-- <div class="field col-12 md:col-2">  
                                <label htmlFor="applicationID">Application ID : {{appID}}</label>
                                </div> -->

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                        <label htmlFor="topSizeLength">Top Size :
                                            <div class="d-flex justify-content-around!important">
                                            <div
                                                *ngIf="tankFormControlsStage2.topSizeLength.touched && tankFormControlsStage2.topSizeLength.valid">
                                                {{'LENGTH' | translate}} : {{submitEstimateFormStage2.get('topSizeLength').value}}
                                            </div>
                                            <div
                                                *ngIf="tankFormControlsStage2.topSizeBreadth.touched && tankFormControlsStage2.topSizeBreadth.valid">
                                                {{'BREADTH' | translate}} : {{submitEstimateFormStage2.get('topSizeBreadth').value}}
                                            </div>
                                            </div>
                                        </label><br><br><br>
                                        <input formControlName="topSizeLength" pInputText id="topSizeLength"
                                            type="number" placeholder="Length"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.topSizeLength.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControlsStage2.topSizeLength.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.topSizeLength.errors.required">{{'LENGTH_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>

                                        <p class="text-center mt-3">X</p>

                                        <input formControlName="topSizeBreadth" pInputText id="topSizeBreadth"
                                            type="number" placeholder="Breadth"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.topSizeBreadth.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControlsStage2.topSizeBreadth.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.topSizeBreadth.errors.required">{{'BREADTH_IS_REQUIRED'|translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                        <label htmlFor="bottomSizeLength">{{'BOTTOM_SIZE' | translate}} :
                                            <div
                                                *ngIf="tankFormControlsStage2.bottomSizeLength.touched && tankFormControlsStage2.bottomSizeLength.valid">
                                                {{'LENGTH' | translate}} : {{submitEstimateFormStage2.get('bottomSizeLength').value}}
                                            </div>
                                            <div
                                                *ngIf="tankFormControlsStage2.bottomSizeBreadth.touched && tankFormControlsStage2.bottomSizeBreadth.valid">
                                                {{'BREADTH' | translate}} : {{submitEstimateFormStage2.get('bottomSizeBreadth').value}}
                                            </div>
                                        </label><br><br><br>
                                        <input formControlName="bottomSizeLength" pInputText id="bottomSizeLength"
                                            type="number" placeholder="Length"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.bottomSizeLength.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControlsStage2.bottomSizeLength.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.bottomSizeLength.errors.required">{{'LENGTH_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>

                                        <p class="text-center mt-3">X</p>

                                        <input formControlName="bottomSizeBreadth" pInputText id="bottomSizeBreadth"
                                            type="number" placeholder="Breadth"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.bottomSizeBreadth.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControlsStage2.bottomSizeBreadth.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.bottomSizeBreadth.errors.required">
                                                {{'BREADTH_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                        <label htmlFor="depth">Depth: </label><br><br><br>
                                        <input formControlName="depth" pInputText id="depth" type="number"
                                            placeholder="Depth"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.depth.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControlsStage2.depth.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.depth.errors.required">{{'DEPTH_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2">
                                        <label htmlFor="typeOfPond">{{'TYPE_OF_POND' | translate}} : </label><br><br><br>
                                        <p-dropdown [options]="pondType" placeholder="Select Type of Pond"
                                            optionLabel="name" formControlName="typeOfPond"></p-dropdown>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                        <label htmlFor="toalCostOfWaterTank">{{'TOTAL_COST_OF_WATER_TANK' | translate}}: </label><br><br>
                                        <input formControlName="toalCostOfWaterTank" pInputText id="toalCostOfWaterTank"
                                            type="number" placeholder="Enter Total Cost of Water Tank"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.toalCostOfWaterTank.errors }"
                                            style="margin-top:4px;" />
                                        <div *ngIf="isSubmitted && tankFormControlsStage2.toalCostOfWaterTank.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.toalCostOfWaterTank.errors.required">
                                               {{'TOTAL_COST_OF_WATER_TANK_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                        <label htmlFor="totalAmountOfSubsidy">{{'TOTAL_AMOUNT_OF_SUBSIDY_(@_70%_OF_TOTAL_COST_OF_INDIVIDUAL_OR_@_85%_OF_TOTAL_COST_OF_COMMUNITY_TANK)' | translate}} : </label>
                                        <input formControlName="totalAmountOfSubsidy" pInputText
                                            id="totalAmountOfSubsidy" type="number"
                                            placeholder="Enter Total Amount of Subsidy"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.totalAmountOfSubsidy.errors }"
                                            style="margin-top:5px;" />
                                        <div *ngIf="isSubmitted && tankFormControlsStage2.totalAmountOfSubsidy.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.totalAmountOfSubsidy.errors.required">
                                                {{'TOTAL_AMOUNT_OF_SUBSIDY_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                        <label htmlFor="amountOfTotalSubsidy">{{'AMOUNT_OF_TOTAL_SUBSIDY' | translate}} : </label>
                                        <input formControlName="amountOfTotalSubsidy" pInputText
                                            id="amountOfTotalSubsidy" type="number"
                                            placeholder="Enter Amount of Subsidy"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.amountOfTotalSubsidy.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControlsStage2.amountOfTotalSubsidy.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.amountOfTotalSubsidy.errors.required">
                                                {{'AMOUNT_OF_SUBSIDY_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                        <label htmlFor="AssistancePaidAtStage2">{{'ASSISTANCE_PAID_AT_STAGE2' | translate}} : </label>
                                        <input formControlName="AssistancePaidAtStage2" pInputText
                                            id="AssistancePaidAtStage2" type="number"
                                            placeholder="Enter Amount of Subsidy"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.AssistancePaidAtStage2.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControlsStage2.AssistancePaidAtStage2.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.AssistancePaidAtStage2.errors.required">
                                                {{'ASSISTANCE_PAID_AT_STAGE-2_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field col-12 md:col-2">
                                        <label htmlFor="block">{{'UPLOAD_MEASUREMENT_BOOK_COPY' | translate}} :</label><br>
                                        <div class="flex" style="margin-top:8px;">
                                            <p-fileUpload accept=".jpeg,.pdf,.jpg" #measurementBookCopyPathStage2
                                                [customUpload]="true"
                                                (uploadHandler)="onUpload($event, 'measurementBookCopyPathStage2', measurementBookCopyPathStage2,3)"
                                                name="myfile[]" mode="basic" [maxFileSize]="1000000"
                                                chooseLabel="Browse" [auto]="true">
                                            </p-fileUpload>
                                            <p-image *ngIf="tankFormControlsStage2.measurementBookCopyPathStage2.value"
                                                [src]="tankFormControlsStage2.measurementBookCopyPathStage2.value"
                                                alt="Image" width="60" class="ml-2 p-button-rounded p-button-success"
                                                iconPos="left">
                                            </p-image>

                                        </div>
                                        <div *ngIf="isSubmitted && tankFormControlsStage2.measurementBookCopyPathStage2.errors"
                                            class="invalid-feedback">
                                            <div
                                                *ngIf="tankFormControlsStage2.measurementBookCopyPathStage2.errors.required">
                                               {{'MEASUREMENT_BOOK_COPY_IS_REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="field col-12 md:col-2">
                                <label htmlFor="remarks">Remarks : </label>
                                <input formControlName="remarks" pInputText id="remarks" type="text"
                                    placeholder="Remarks"
                                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.remarks.errors }" />
                                <div *ngIf="isSubmitted && tankFormControlsStage2.remarks.errors"
                                    class="invalid-feedback">
                                    <div *ngIf="tankFormControlsStage2.remarks.errors.required">Remarks is required
                                    </div>
                                </div>
                            </div> -->


                                </div>
                                <div>
                                    <span style="font-weight: bold;">{{'NOTE' | translate}}: </span>
                                    <span style="color: #EA5455;">{{'ONLY_PDF_FILES_ALLOWED' | translate}}.</span>
                                </div>

                                <!-- <button (click)="submitEstimate2()" pButton pRipple type="submit" label="Submit Estimate"
                        class="p-button-success mr-2 mb-2"></button> -->

                            </form>
                        </div>
                        <div>
                            <span style="font-weight: bold;">{{'NOTE' | translate}}: </span>
                            <span style="color: #EA5455;">{{'PLEASE_FILL_DETAILS_PHYSICAL_VERIFICATION' | translate}}</span>
                        </div>
                    </div>

                    <div class="card dropdown-content" style="margin: 5px;">
                        <div class="p-fluid p-formgrid grid d-flex justify-content-end">
                            <div class="field col-12 md:col-2">
                                <br>
                                <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                                    class="mr-3"></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-2">
                                <textarea id="description" [(ngModel)]="stage2EstimateFormremarks" placeholder="Remarks"
                                    pInputTextarea required rows="3" cols="20" class="mr-3"></textarea>
                            </div>
                            <div class="field col-12 md:col-2">
                                <br>
                                <button pButton pRipple label="{{'SUBMIT' | translate}}" type="submit" (click)="submitEstimateStage2()"
                                    class="p-button-help"></button>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template [ngIf]="!wrongNotificationCheck2">
                    <div class="col-12">
                        <div class="card intimation-header">
                            <form [formGroup]="submitFalseIntimateFormStage2" (onChange)="wrongNotification2($event)">

                                <div class="p-fluid p-formgrid grid">
                                    <!-- <div class="field col-12">
                                <label htmlFor="applicationID">Application ID : {{appID}}</label>
                            </div> -->

                                    <div class="field col-12 md:col-4">
                                        <label htmlFor="block">{{'UPLOAD_THE_PHOTO_TAKEN' | translate}}* : </label>
                                        <div class="flex">
                                            <p-fileUpload accept=".jpeg,.pdf,.jpg" #uploadThePhotoTaken
                                                [customUpload]="true"
                                                (uploadHandler)="onUpload($event, 'uploadThePhotoTaken', uploadThePhotoTaken,4)"
                                                name="myfile[]" mode="basic" [maxFileSize]="1000000"
                                                chooseLabel="Browse" [auto]="true">
                                            </p-fileUpload>
                                            <p-image *ngIf="falseIntimationFormControlsStage2.uploadThePhotoTaken.value"
                                                [src]="falseIntimationFormControlsStage2.uploadThePhotoTaken.value"
                                                alt="Image" width="60" class="ml-2 p-button-rounded p-button-success"
                                                iconPos="left"></p-image>
                                        </div>
                                        <!-- <input type="file" name="image" style="border:solid 1px #e7eaed;padding:4px;"> -->
                                    </div>


                                    <!-- <div class="field col-12 md:col-4">
                            <label htmlFor="remarks">Remarks : </label>
                            <input formControlName="remarks" pInputText id="remarks" type="text" placeholder="Remarks"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && falseIntimationFormControlsStage2.remarks.errors }" />
                            <div *ngIf="isSubmitted && falseIntimationFormControlsStage2.remarks.errors"
                                class="invalid-feedback">
                                <div *ngIf="falseIntimationFormControlsStage2.remarks.errors.required">Remarks is
                                    required
                                </div>
                            </div>
                        </div> -->

                                </div>
                                <br>
                                <div>
                                    <span style="font-weight: bold;">{{'NOTE' | translate}}: </span>
                                    <span style="color: #EA5455;">{{'ONLY_JPG,PNG_OR_PDF_PHOTO_ALLOWED' | translate}}.</span>
                                </div>
                                <br>
                                <!-- <button (click)="submitEstimate2()" pButton pRipple type="submit" label="Submit Estimate"
                            class="p-button-success mr-2 mb-2"></button> -->
                            </form>
                        </div>
                    </div>
                    <div class="card dropdown-content" style="margin: 5px;">
                        <div class="p-fluid p-formgrid grid d-flex justify-content-end">
                            <div class="field col-12 md:col-2">
                                <br>
                                <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                                    class="mr-3"></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-2">
                                <textarea id="description" [(ngModel)]="stage2FalseIntimationremarks"
                                    placeholder="Remarks" pInputTextarea required rows="3" cols="20"
                                    class="mr-3"></textarea>
                            </div>
                            <div class="field col-12 md:col-2">
                                <br>
                                <button pButton pRipple label="{{'SUBMIT' | translate}}" type="submit"
                                    (click)="submitFalseIntimateStage2()" class="p-button-help"></button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </p-card>
    </div>
</p-dialog>
<!-- Tank Dialog 2 Ends Here -->